import type { ReactElement } from 'react';
import { BrandLogo } from '@/shared/ui';

/**
 * 관리자 로그인 왼쪽 브랜드 면 — 사진 없이 흑연 판에 큰 SS 무늬와 라임·민트 빛 번짐,
 * 그 위에 흰 로고·라임 선·"Admin Center" 문구. 고객 웹 로그인의 배너 없는 판과 같은 모양이다.
 * 꾸밈이라 보조기기에서는 감춘다 — 화면 이름은 오른쪽 폼의 h1 이 준다.
 */
export const AdminAuthPanel = (): ReactElement => (
  <div
    aria-hidden
    className="relative isolate flex h-full flex-col overflow-hidden bg-primary text-white"
  >
    <div className="absolute -top-24 -right-32 size-96 rounded-full bg-brand-lime/25 blur-3xl" />
    <div className="absolute -bottom-32 -left-24 size-96 rounded-full bg-brand-mint/20 blur-3xl" />
    <BrandLogo className="absolute top-1/4 -right-48 h-72 text-white/[0.05]" />

    <div className="relative flex flex-1 flex-col justify-between p-12 xl:p-16">
      <BrandLogo className="h-10 self-start" />
      <div>
        <span className="block h-1 w-16 bg-brand-lime" />
        <p className="mt-8 text-[clamp(2.5rem,4vw,3.5rem)] leading-none font-bold tracking-[-0.03em]">
          Admin Center
        </p>
        <p className="mt-5 text-[15px] text-white/75">운영자 전용 — 상품·견적·결제를 관리합니다.</p>
      </div>
    </div>
  </div>
);
